import React from 'react'

const TableViewIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="#C4C4C4" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.25 6.25H6.25V0.25H0.25V6.25ZM1.75 1.75H4.75V4.75H1.75V1.75ZM7.75 13.75H13.75V7.75H7.75V13.75ZM9.25 9.25H12.25V12.25H9.25V9.25ZM0.25 13.75H6.25V7.75H0.25V13.75ZM1.75 9.25H4.75V12.25H1.75V9.25ZM7.75 0.25V6.25H13.75V0.25H7.75ZM12.25 4.75H9.25V1.75H12.25V4.75Z" fill="#C4C4C4" />
  </svg>
)

export default TableViewIcon;